import { useRef } from 'react';

const useMediaStream = (videoRef) => {
  const startPreviewMedia = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: 'environment' },
      // audio: true,
    });
    if (videoRef.current) {
        videoRef.current.srcObject = stream;
    }
    return stream;
  };

  const stopMedia = () => {
    if (videoRef?.current?.current?.srcObject) {
      const src = videoRef?.current?.current?.srcObject
      src.getTracks().forEach((track) => track.stop());
      videoRef.current.current.srcObject = null;
    }
  };

  return { videoRef, startPreviewMedia, stopMedia };
};

export default useMediaStream;